import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { ScrollArea } from "@/components/ui/scroll-area";

const DeveloperJobSearch = () => {
  const jobs = [
    {
      id: 1,
      title: "Senior React Developer",
      company: "Tech Solutions Inc",
      location: "Remote",
      salary: "$120k - $160k",
      description: "Looking for an experienced React developer to join our team...",
    },
    {
      id: 2,
      title: "Full Stack Developer",
      company: "Digital Innovations",
      location: "Remote",
      salary: "$100k - $140k",
      description: "Seeking a full stack developer with experience in React and Node.js...",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle>Job Search</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex gap-4 mb-6">
              <Input placeholder="Search jobs..." className="flex-1" />
              <Button>Search</Button>
            </div>

            <ScrollArea className="h-[600px] pr-4">
              <div className="space-y-4">
                {jobs.map((job) => (
                  <Card key={job.id}>
                    <CardContent className="p-4">
                      <div className="space-y-2">
                        <div className="flex justify-between items-start">
                          <h3 className="font-semibold text-lg">{job.title}</h3>
                          <span className="text-sm text-gray-600">{job.salary}</span>
                        </div>
                        <p className="text-sm text-gray-600">{job.company} • {job.location}</p>
                        <p className="text-sm text-gray-500">{job.description}</p>
                        <Button variant="outline" className="w-full mt-2">Apply Now</Button>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </ScrollArea>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default DeveloperJobSearch;